import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";

import "./index.css";
import { Toaster } from "@/components/ui/sonner";
import { Home } from "./pages/home/home";
import { About } from "./pages/about/about";
import { Contact } from "./pages/contact/contact";
import Navbar from "./components/navbar/navbar";
import { Footer } from "./components/footer/footer";
import { Benefits } from "./pages/benefits/benefits";
import { Loyalty } from "./pages/loyalty/loyalty";
import { PromoRewards } from "./pages/promo&rewards/promo-rewards";
import { DigitalSignage } from "./pages/digital-signage/digital-signage";
import { MusicAudioMessaging } from "./pages/music-audio-messaging/messaging";
import { Streamee } from "./pages/streamee/streamee";
import { News } from "./pages/news/news";
import { NewsDetail } from "./pages/news/news-detail";
import { Partners } from "./pages/partners/partners";
import { PaduApp } from "./pages/padu-app/padu";
import { ZitaPlirofories } from "./pages/zita-plirofories/zita-plir";
import { AdminPage } from "./pages/admin/admin";
import { LoginPage } from "./pages/admin/login";
import { isLoggedIn } from "./hooks/useAuth";
import { Antamoivi } from "./pages/antamoivi/antamoivi";
import { ProgrammataPistotitas } from "./pages/programmata-pistotitas/programmata-pistotitas";
import { MiniaiesKlirosis } from "./pages/miniaies-klirosis/miniaies-klirosis";
import { RetailMedia } from "./pages/retail-media/retail-media";
import { Nova } from "./pages/nova/nova";
import { Legal } from "./pages/legal/legal";
import { CAMPAIGNS } from "./pages/qr-redirect/redirects";
import { RedirectPage } from "./pages/qr-redirect/RedirectPage";
import { LandingPreview } from "./pages/qr-redirect/LandingPreview";
import { Cookies } from "./pages/cookies/cookies";
import { trackPageView } from "./lib/analytics";
import { LandingPage } from "./pages/landing/LandingPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname, search);
  }, [pathname, search]);
  return null;
}

function MainLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  return isLoggedIn() ? <>{children}</> : <Navigate to="/admin/login" replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsTracker />
      <Toaster
        position="top-center"
        toastOptions={{
          classNames: {
            success: "!bg-[#00d9d9] !text-black !border-[#00d9d9]",
            description: "!text-black/70",
          },
        }}
      />
      <Routes>
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/l/:slug" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/loyalty" element={<Loyalty />} />
          <Route path="/promo-and-rewards" element={<PromoRewards />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/digital-signage" element={<DigitalSignage />} />
          <Route path="/music-audio-messaging" element={<MusicAudioMessaging />} />
          <Route path="/streamee-for-bussiness" element={<Streamee />} />
          <Route path="/padu-app" element={<PaduApp />} />
          <Route path="/zita-plirofories-kai-prosfora" element={<ZitaPlirofories />} />
          <Route path="/ta-nea-mas" element={<News />} />
          <Route path="/ta-nea-mas/:id" element={<NewsDetail />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/antamoivi-se-kathe-agora" element={<Antamoivi />} />
          <Route path="/programmata-pistotitas" element={<ProgrammataPistotitas />} />
          <Route path="/miniaies-klirosis" element={<MiniaiesKlirosis />} />
          <Route path="/retail-media" element={<RetailMedia />} />
          <Route path="/nova" element={<Nova />} />
          <Route path="/terms" element={<Legal slug="terms" fallbackTitle="Όροι Χρήσης" />} />
          <Route path="/oroi-xrisis" element={<Legal slug="terms" fallbackTitle="Όροι Χρήσης" />} />
          <Route path="/privacy" element={<Legal slug="privacy" fallbackTitle="Πολιτική Απορρήτου" />} />
          <Route path="/politiki-aporritou" element={<Legal slug="privacy" fallbackTitle="Πολιτική Απορρήτου" />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/qr-landing/:slug" element={<LandingPreview />} />
          {CAMPAIGNS.flatMap((campaign) =>
            campaign.paths.map((path) => (
              <Route
                key={path}
                path={path}
                element={<RedirectPage campaign={campaign} path={path} />}
              />
            ))
          )}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
